(function() {
    let tlFreeGiftOfferClone;

    const updateProductDataByProductId = async (productIds) => {
        if (!Array.isArray(productIds) || productIds.length === 0) return;

        const STOREFRONT_TOKEN = window.tlFreeGiftOffer.storeAccessToken;
        const endpoint = '/api/2025-01/graphql.json';

        // Convert numeric id -> gid
        const gids = productIds.map(id => `gid://shopify/Product/${id}`);

        const query = `
        query getProducts($ids: [ID!]!) {
            nodes(ids: $ids) {
            ... on Product {
                id
                title
                handle
                availableForSale
                tags
                images(first: 1) {
                    edges {
                        node {
                            url
                        }
                    }
                }
                variants(first: 50) {
                    edges {
                        node {
                            id
                            title
                            availableForSale
                            price {
                                amount
                            }
                            image {
                                url
                            }
                        }
                    }
                }
            }
            }
        }
        `;

        let data;
        try {
            const res = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
                },
                body: JSON.stringify({
                    query,
                    variables: { ids: gids }
                })
            });

            const json = await res.json();
            data = json.data?.nodes || [];
        } catch (e) {
            console.error('Fetch products error', e);
            return;
        }

        data.forEach(product => {
            if (!product) return;
            const currencyRate = window.tlFreeGiftOffer.currencyRate;
            // Convert GID -> numeric id
            const productId = product.id.split('/').pop();

            const productImage =
                product.images?.edges?.[0]?.node?.url ||
                window.tlFreeGiftOffer.fallBackImg;

            const variants = (product.variants?.edges || []).map(edge => {
                const v = edge.node;
                const variantId = v.id.split('/').pop();

                const mappedVariant = {
                    id: variantId,
                    title: product.title,
                    handle: product.handle,
                    image: v.image?.url || productImage,
                    price: parseFloat(v.price.amount * currencyRate),
                    available: v.availableForSale,
                    productId: productId
                };

                window.tlFreeGiftOffer.shopifyIdMapData.set(variantId, mappedVariant);

                return mappedVariant;
            });

            // Giữ nguyên format product như code cũ
            window.tlFreeGiftOffer.shopifyIdMapData.set(productId, {
                id: productId,
                title: product.title,
                handle: product.handle,
                image: productImage,
                price: +(variants[0]?.price * currencyRate).toFixed(2) || 0,
                available: product.availableForSale,
                tags: product.tags,
                variants: variants
            });
        });
    };

    Object.defineProperty(window, "tlFreeGiftOffer", {
        get() {
            return tlFreeGiftOfferClone;
        },
        set(val) {
            if (val && !tlFreeGiftOfferClone) {
                tlFreeGiftOfferClone = val;

                val.fetchNextProductBatch = async (rule, isFetchGift = true) => {
                    const {
                        id: ruleId, listChilds, listParents,
                        hide_gift_out_of_stock: hideOutOfStock
                    } = rule;

                    const { ROW_PER_PAGE } = window.tlFreeGiftOffer.constants;

                    const fetchingStatus = { 
                        is_complete_fetching: false, 
                        last_index: 0,
                        ...(isFetchGift 
                            ? window.tlFreeGiftOffer.ruleIdMapFetchingGiftStatus.get(ruleId) ?? {}
                            : window.tlFreeGiftOffer.ruleIdMapFetchingCustomerBuyStatus.get(ruleId) ?? {}
                        )
                    };

                    const fetchedGifts = isFetchGift 
                        ? window.tlFreeGiftOffer.ruleIdMapFetchedGifts.get(ruleId) ?? []
                        : window.tlFreeGiftOffer.ruleIdMapFetchedCustomers.get(ruleId) ?? [];
                    if(fetchingStatus.is_complete_fetching){
                        return fetchedGifts;
                    }else{
                        const gifts = [];
                        const listItems = isFetchGift ? listChilds : listParents;
                        const itemsLength = listItems.length;
                        
                        while (gifts.length < ROW_PER_PAGE && fetchingStatus.last_index < itemsLength) {
                            const batchProducts = [];
                            const productsToFetch = [];

                            let i = fetchingStatus.last_index;
                            for (; i < itemsLength && batchProducts.length + productsToFetch.length < ROW_PER_PAGE - gifts.length; i++) {
                                const { shopify_id, handle, quantity, product_id } = listItems[i];

                                const childData = window.tlFreeGiftOffer.shopifyIdMapData.get(shopify_id)
                                if (childData) {
                                    batchProducts.push({ quantity, ...childData });
                                    continue;
                                }

                                productsToFetch.push({ shopify_id, handle, quantity });
                            }
                            fetchingStatus.last_index = i;

                            if (productsToFetch.length) {
                                const productIds = [...new Set(productsToFetch.map(({ product_id }) => product_id))];
                                await updateProductDataByProductId(productIds);
                                const newProducts = productsToFetch.map(({ shopify_id, quantity }) =>  ({
                                    quantity,
                                    ...window.tlFreeGiftOffer.shopifyIdMapData.get(shopify_id),
                                }));
                                batchProducts.push(...newProducts);
                            }

                            const filtered = hideOutOfStock ? batchProducts.filter((p) => p?.available) : batchProducts;

                            gifts.push(...filtered);
                        }

                        if (fetchingStatus.last_index >= itemsLength) {
                            fetchingStatus.is_complete_fetching = true;
                        }
                        if(isFetchGift){
                            window.tlFreeGiftOffer.ruleIdMapFetchingGiftStatus.set(ruleId, fetchingStatus);
                            window.tlFreeGiftOffer.ruleIdMapFetchedGifts.set(ruleId, [...fetchedGifts, ...gifts]);
                        }else {
                            window.tlFreeGiftOffer.ruleIdMapFetchingCustomerBuyStatus.set(ruleId, fetchingStatus);
                            window.tlFreeGiftOffer.ruleIdMapFetchedCustomers.set(ruleId, [...fetchedGifts, ...gifts]);
                        }
                        return gifts;
                    }
                };

                val.findFirstAvailableGift = async (rule) => {
                    let fisrtAvailableGift = null;
                    for (const child of rule.listChilds) {
                        const {shopify_id: giftId, handle, product_id: productId} = child;
                        let giftData = window.tlFreeGiftOffer.shopifyIdMapData.get(giftId)
                        if(!giftData){
                            await updateProductDataByProductId([productId]);
                            giftData = window.tlFreeGiftOffer.shopifyIdMapData.get(giftId);
                        }

                        if(giftData && giftData.available){
                            fisrtAvailableGift = giftData;
                            break;
                        }
                    }

                    return fisrtAvailableGift
                }
            }
        },
        configurable: true
    });
})();